import { canvasCopy } from "../copy/zh-CN.js";
import type { CanvasRecoveryState, SaveState } from "./session-controller.js";
import type { CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";

export function confirmCanvasNavigation(recovery: CanvasRecoveryState, confirm: (message: string) => boolean): boolean {
  return recovery.durable || confirm(canvasCopy.unsavedLeave);
}

export function protectCanvasUnload(event: Event, recovery: CanvasRecoveryState): void {
  if (!recovery.durable) {
    event.preventDefault();
    (event as BeforeUnloadEvent).returnValue = "";
  }
}

export function exportLatestCanvas(
  current: () => CanvasDocument | undefined,
  download: (content: string) => void = (content) => {
    const url = URL.createObjectURL(new Blob([content], { type: "application/json" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = "画布恢复副本.json";
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
): void {
  const latest = current();
  if (latest) download(JSON.stringify(latest, null, 2));
}

export function canvasSaveStatusLabel(status: SaveState): string {
  switch (status.status) {
    case "saved":
      return canvasCopy.saved;
    case "saving":
      return canvasCopy.saving;
    case "offline_draft":
      return canvasCopy.offlineDraft;
    case "save_failed":
      return canvasCopy.saveFailed;
    case "conflict":
      return canvasCopy.conflict;
    default:
      return canvasCopy.loading;
  }
}

export function shouldPersistCanvasViewChange(): false {
  return false;
}
